import React from 'react';
import './css/emptyState.css';

interface EmptyStateProps {
  message: string;
  subMessage: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ message, subMessage }) => (
  <div className="empty-state">
    <p className="empty-state-message">{message}</p>
    <p className="empty-state-submessage">{subMessage}</p>
  </div>
);

export default EmptyState;
